import React from "react";
import About from "../components/about/about";
import Header from "../components/Header/header";
import Navbar from "../components/navbar/navbar";

const AboutPage = () => (
  <div>
    <Navbar />
    <Header />
    <About />
  </div>
);

export default AboutPage;
